/* =========================================================
   PS x KIKI — Motion & Interaction Engine
   ========================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll Reveals (Sweep-basiert, springfest) ---------- */
  var pendingReveals = [];
  var sweepQueued = false;

  function sweepReveals() {
    if (!pendingReveals.length) return;
    var h = window.innerHeight || 800;
    var still = [];
    for (var i = 0; i < pendingReveals.length; i++) {
      var el = pendingReveals[i];
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.94) {
        el.classList.add('is-in');
      } else {
        still.push(el);
      }
    }
    pendingReveals = still;
  }

  function queueSweep() {
    if (sweepQueued) return;
    sweepQueued = true;
    window.requestAnimationFrame(function () {
      sweepQueued = false;
      sweepReveals();
    });
  }

  function initReveals(scope) {
    var root = scope || document;

    var groups = root.querySelectorAll('[data-kk-stagger]:not([data-kk-stagger-ready])');
    [].forEach.call(groups, function (group) {
      group.setAttribute('data-kk-stagger-ready', '1');
      var step = parseInt(group.getAttribute('data-kk-stagger'), 10) || 70;
      var kids = group.children;
      for (var i = 0; i < kids.length; i++) {
        if (!kids[i].hasAttribute('data-kk-reveal')) kids[i].setAttribute('data-kk-reveal', '');
        kids[i].style.setProperty('--kk-delay', (i % 8) * step + 'ms');
      }
    });

    var nodes = root.querySelectorAll('[data-kk-reveal]:not([data-kk-ready])');
    [].forEach.call(nodes, function (node) {
      node.setAttribute('data-kk-ready', '1');
      if (reduce) { node.classList.add('is-in'); return; }
      pendingReveals.push(node);
    });

    sweepReveals();
  }

  window.addEventListener('scroll', queueSweep, { passive: true });
  window.addEventListener('resize', queueSweep);
  window.addEventListener('load', sweepReveals);

  /* ---------- 2. Hero Slideshow ---------- */
  function initHero(scope) {
    (scope || document).querySelectorAll('[data-kk-hero]').forEach(function (hero) {
      if (hero.dataset.kkReady === '1') return;
      hero.dataset.kkReady = '1';

      var slides = [].slice.call(hero.querySelectorAll('.kk-hero__slide'));
      var dots = [].slice.call(hero.querySelectorAll('.kk-hero__dot'));
      if (!slides.length) return;

      var interval = parseInt(hero.dataset.kkInterval, 10) || 6000;
      var current = 0;
      var timer = null;
      var visible = true;

      function paint(index) {
        slides.forEach(function (slide, i) {
          var copy = slide.querySelector('.kk-hero__copy');
          if (i === index) {
            slide.classList.add('is-active');
            slide.classList.remove('is-leaving');
            slide.removeAttribute('aria-hidden');
            if (copy) {
              copy.classList.remove('is-in');
              void copy.offsetWidth;
              copy.classList.add('is-in');
            }
          } else {
            if (slide.classList.contains('is-active')) {
              slide.classList.add('is-leaving');
              window.setTimeout(function () { slide.classList.remove('is-leaving'); }, 950);
            }
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
            if (copy) copy.classList.remove('is-in');
          }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        current = index;
      }

      function next() { paint((current + 1) % slides.length); }

      function play() {
        stop();
        if (slides.length < 2 || reduce) return;
        timer = window.setInterval(function () { if (visible) next(); }, interval);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { paint(i); play(); });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () { visible = !document.hidden; });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { visible = e.isIntersecting; });
        }, { threshold: 0.15 }).observe(hero);
      }

      var startX = null;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) {
          paint(dx < 0 ? (current + 1) % slides.length : (current - 1 + slides.length) % slides.length);
          play();
        }
        startX = null;
      }, { passive: true });

      paint(0);
      play();
    });
  }

  /* ---------- 3. Collections Slider ---------- */
  function initSlider(scope) {
    (scope || document).querySelectorAll('[data-kk-slider]').forEach(function (root) {
      if (root.dataset.kkReady === '1') return;
      root.dataset.kkReady = '1';

      var track = root.querySelector('.kk-cs__track');
      var slides = [].slice.call(root.querySelectorAll('.kk-cs__slide'));
      var dots = [].slice.call(root.querySelectorAll('.kk-cs__dot'));
      if (!track || !slides.length) return;

      var interval = parseInt(root.dataset.kkInterval, 10) || 5000;
      var index = 0;
      var timer = null;
      var visible = true;

      function paint(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translate3d(-' + index * 100 + '%,0,0)';
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === index);
          d.setAttribute('aria-current', di === index ? 'true' : 'false');
        });
      }
      function play() {
        stop();
        if (slides.length < 2 || reduce) return;
        timer = window.setInterval(function () { if (visible) paint(index + 1); }, interval);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

      dots.forEach(function (d, i) { d.addEventListener('click', function () { paint(i); play(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);

      var sx = null;
      root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) paint(index + (dx < 0 ? 1 : -1));
        sx = null;
        play();
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { visible = e.isIntersecting; });
        }, { threshold: 0.2 }).observe(root);
      }

      paint(0);
      play();
    });
  }

  /* ---------- 4. FAQ Accordion ---------- */
  function initFaq(scope) {
    (scope || document).querySelectorAll('[data-kk-faq]').forEach(function (root) {
      if (root.dataset.kkReady === '1') return;
      root.dataset.kkReady = '1';
      var single = root.dataset.kkSingle !== 'false';

      root.querySelectorAll('.kk-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.kk-faq__item');
          if (!item) return;
          var open = item.classList.contains('is-open');
          if (single) {
            root.querySelectorAll('.kk-faq__item.is-open').forEach(function (other) {
              if (other !== item) {
                other.classList.remove('is-open');
                var ob = other.querySelector('.kk-faq__q');
                if (ob) ob.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---------- 5. Marquee-Tempo an Inhalt anpassen ---------- */
  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-kk-marquee]').forEach(function (root) {
      if (root.dataset.kkReady === '1') return;
      root.dataset.kkReady = '1';
      var track = root.querySelector('.kk-marquee__track');
      var group = root.querySelector('.kk-marquee__group');
      if (!track || !group) return;
      var pps = parseFloat(root.dataset.kkSpeed) || 55;
      function sync() {
        var w = group.scrollWidth;
        if (!w) return;
        track.style.setProperty('--kk-dur', Math.max(14, Math.round(w / pps)) + 's');
      }
      sync();
      window.addEventListener('resize', sync);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
      window.setTimeout(sync, 800);
    });
  }

  /* ---------- 6. Filter Drawer ---------- */
  function initDrawer(scope) {
    (scope || document).querySelectorAll('[data-kk-drawer]').forEach(function (drawer) {
      if (drawer.dataset.kkReady === '1') return;
      drawer.dataset.kkReady = '1';
      var id = drawer.getAttribute('data-kk-drawer');
      var openers = document.querySelectorAll('[data-kk-drawer-open="' + id + '"]');
      var closers = drawer.querySelectorAll('[data-kk-drawer-close]');

      function open() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ps-overlay-open');
      }
      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ps-overlay-open');
      }
      [].forEach.call(openers, function (o) { o.addEventListener('click', open); });
      [].forEach.call(closers, function (c) { c.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  /* ---------- 7. Produktseite: Detailblock aus dem Grid holen ----------
     Sonst spannt die lange Infospalte ueber zwei Grid-Zeilen und die
     klebende Galerie schiebt sich ueber die Produktdetails.            */
  function initPdpLayout() {
    var grid = document.querySelector('.ps-pdp__grid');
    if (!grid || grid.dataset.kkLayoutReady === '1') return;
    grid.dataset.kkLayoutReady = '1';

    var details = null;
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].classList.contains('ps-pdp-details')) {
        details = grid.children[i];
        break;
      }
    }
    if (!details || !grid.parentNode) return;
    grid.parentNode.insertBefore(details, grid.nextSibling);
  }

  /* ---------- 8. Produktseite: Module einsortieren ---------- */
  function initPdpSlots(scope) {
    var root = scope || document;
    var info = root.querySelector('.ps-pdp__info') || document.querySelector('.ps-pdp__info');
    if (!info) return;

    var slots = root.querySelectorAll('[data-kk-slot]');
    [].forEach.call(slots, function (slot) {
      if (slot.dataset.kkPlaced === '1') return;
      var where = slot.getAttribute('data-kk-slot');

      if (where === 'proof') {
        if (info.firstElementChild) info.insertBefore(slot, info.firstElementChild);
        else info.appendChild(slot);
      } else if (where === 'tiles' || where === 'delivery') {
        var anchor = info.querySelector('.ps-product-form-wrap') || info.querySelector('product-form');
        if (anchor && anchor.parentNode === info) {
          if (where === 'tiles') {
            info.insertBefore(slot, anchor.nextSibling);
          } else {
            var tiles = info.querySelector('[data-kk-slot="tiles"]');
            var ref = tiles && tiles.parentNode === info ? tiles.nextSibling : anchor.nextSibling;
            info.insertBefore(slot, ref);
          }
        } else {
          info.appendChild(slot);
        }
      } else {
        info.appendChild(slot);
      }
      slot.dataset.kkPlaced = '1';
    });
  }

  /* ---------- 9. Marke auf der Produktseite verlinken ---------- */
  function initVendorLink() {
    var stage = document.querySelector('.kk-pdp-stage[data-kk-vendor-url]');
    if (!stage) return;
    var url = stage.getAttribute('data-kk-vendor-url');
    if (!url) return;

    var el = document.querySelector('.ps-pdp__vendor');
    if (!el || el.dataset.kkVendorReady === '1') return;
    el.dataset.kkVendorReady = '1';

    var existing = el.querySelector('a');
    if (existing) {
      existing.setAttribute('href', url);
      existing.classList.add('kk-vendor-link');
      existing.setAttribute('title', 'Alle Teile von ' + existing.textContent.trim() + ' ansehen');
      return;
    }

    var label = (el.textContent || '').trim();
    if (!label) return;

    var link = document.createElement('a');
    link.className = 'kk-vendor-link';
    link.href = url;
    link.textContent = label;
    link.setAttribute('title', 'Alle Teile von ' + label + ' ansehen');
    el.textContent = '';
    el.appendChild(link);
  }

  /* ---------- 10. Liefer-Timeline ---------- */
  function initTimeline(scope) {
    (scope || document).querySelectorAll('[data-kk-timeline]:not([data-kk-tl-ready])').forEach(function (tl) {
      tl.setAttribute('data-kk-tl-ready', '1');
      if (reduce) { tl.classList.add('is-in'); return; }
      pendingReveals.push(tl);
    });
    sweepReveals();
  }

  /* ---------- 11. Header-Zustand beim Scrollen ---------- */
  function initHeaderScroll() {
    if (document.documentElement.dataset.kkHeaderReady === '1') return;
    document.documentElement.dataset.kkHeaderReady = '1';
    function onScroll() {
      document.documentElement.classList.toggle('kk-scrolled', (window.scrollY || 0) > 12);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    initPdpLayout();
    initPdpSlots(scope);
    initVendorLink();
    initReveals(scope);
    initHero(scope);
    initSlider(scope);
    initFaq(scope);
    initMarquee(scope);
    initDrawer(scope);
    initTimeline(scope);
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });

  window.PSKiki = { init: initAll, sweep: sweepReveals };
})();